import { byMedia } from '../helpers/media';
export const wrapMap = new Map();
wrapMap.set(true, 'wrap');
wrapMap.set(false, 'nowrap');
wrapMap.set('reverse', 'wrap-reverse');
export const wrapKeys = [true, false, 'reverse'];
export const flexWrap = byMedia(value => `flex-wrap: ${wrapMap.get(value) || value};`);